// Components
import { StepIntegrationFacebookComponent } from './step-integration-facebook.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_INTEGRATION_FACEBOOK = {
  stepIdentifier: 'mediaUploadFlowStepIntegrationFacebook',
  identifier: 'facebook',
  component: StepIntegrationFacebookComponent,
  name: 'Facebook',
  title: 'Facebook Configuration',
  header: true,
  headerDistinctive: true,
  displayInFlowProgressBar: true,
  canNavigateBack: false,
  subStep: true,
} as MediaUploadFlowStep;
